import { KalturaFavoriteFilter } from '../filters';
import { requestPhoenix } from '../network';
import { KalturaFavorite, KalturaFavoriteListResponse } from '../objects';

export type FetchFavoriteListArgs = {
  filter?: KalturaFavoriteFilter;
};

type AddFavoriteArgs = {
  assetId: number;
  extraData?: string;
};

type DeleteFavoriteArgs = {
  id: number;
};

/**
 * @see https://latest.api-docs-develop.ott.kaltura.com/api-docs/service/favorite/action/list
 */
export async function fetchFavoriteList({ filter }: FetchFavoriteListArgs) {
  const response = await requestPhoenix<KalturaFavoriteListResponse>({
    path: '/favorite/action/list',
    body: { filter },
  });

  return {
    ...response,
    objects: response.objects?.length ? response.objects : [],
  };
}

/**
 * @see https://latest.api-docs-develop.ott.kaltura.com/api-docs/service/favorite/action/add
 */
export async function addFavorite(favorite: AddFavoriteArgs) {
  return requestPhoenix<KalturaFavorite>({
    path: '/favorite/action/add',
    body: { favorite },
  });
}

/**
 * @see https://latest.api-docs-develop.ott.kaltura.com/api-docs/service/favorite/action/delete
 */
export async function deleteFavorite({ id }: DeleteFavoriteArgs) {
  return requestPhoenix<boolean>({
    path: '/favorite/action/delete',
    body: { id },
  });
}
